import { useEffect, useState } from 'react';
import useIndividuals from 'hooks/useIndividuals';
import useTeams from 'hooks/useTeams';

type Props = {
    ownerId?: string;
    teamId?: string;
    createdBy?: string;
};

const useManifestFilterLabels = ({ ownerId, teamId, createdBy }: Props) => {
    const { getIndividual, entities: individualEntities } = useIndividuals();
    const { getTeamById, entities: teamEntities } = useTeams();

    const [ownerName, setOwnerName] = useState<string | undefined>();
    const [teamName, setTeamName] = useState<string | undefined>();
    const [creatorName, setCreatorName] = useState<string | undefined>();

    useEffect(() => {
        if (!ownerId) {
            setOwnerName(undefined);
            return;
        }

        const ind = individualEntities[ownerId];

        if (!ind) {
            getIndividual(ownerId).catch(() => setOwnerName(undefined));
            return;
        }

        setOwnerName(ind?.fullName ?? ind?.email);
    }, [getIndividual, individualEntities, ownerId]);

    useEffect(() => {
        if (!createdBy) {
            setCreatorName(undefined);
            return;
        }

        const ind = individualEntities[createdBy];

        if (!ind) {
            getIndividual(createdBy).catch(() => setCreatorName(undefined));
            return;
        }

        setCreatorName(ind?.fullName ?? ind?.email);
    }, [getIndividual, individualEntities, createdBy]);

    useEffect(() => {
        if (!teamId) {
            setTeamName(undefined);
            return;
        }

        const team = teamEntities[teamId];

        if (!team) {
            getTeamById(teamId).catch(() => setTeamName(undefined));
            return;
        }

        setTeamName(team?.name);
    }, [getTeamById, teamEntities, teamId]);

    return {
        ownerName,
        teamName,
        creatorName,
    };
};

export default useManifestFilterLabels;
